import styled from "styled-components"
import { Link } from "react-router-dom"
import { VARIANTS, MOBILE_VARIANTS } from "./constants"
import { media } from "utils/utils"

export const LogoLink = styled(Link)`
  display: block;
  vertical-align: middle;
  width: ${props => props.width};
  color: ${props => VARIANTS[props.variant].color};
  height: ${props => VARIANTS[props.variant].height};
  margin: ${props => (props.variant === "account" ? 0 : "auto")};

  ${media.md`
    /*margin-left: 70px;
    margin-right: 70px;*/
    height: ${props => MOBILE_VARIANTS[props.variant].height};
  `};
`

export const NoLink = styled.div`
  display: block;
  vertical-align: middle;
  width: ${props => props.width};
  color: ${props => VARIANTS[props.variant].color};
  height: ${props => VARIANTS[props.variant].height};
  margin: ${props => (props.variant === "account" ? 0 : "auto")};

  ${media.md`
    /*margin-left: 70px;
    margin-right: 70px;*/
    height: ${props => MOBILE_VARIANTS[props.variant].height};
  `};
`

export const ILogo = styled.img`
  height: auto;
  max-height: ${props => (props.large ? "130px" : "61px")};
  width: ${props => props.logoWidth};
  margin: ${props => props.logoMargin} auto 0 auto;
  display: block;

  ${media.md`max-width: 100%;`};
`
